import { render } from "./customTag.vue?vue&type=template&id=55cb45f6&scoped=true"
import script from "./customTag.vue?vue&type=script&lang=js"
export * from "./customTag.vue?vue&type=script&lang=js"

import "./customTag.vue?vue&type=style&index=0&id=55cb45f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55cb45f6"

export default script